import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Sidebar from '../component/sidebar';
import Navbar from '../component/navbar';
import { Outlet, useNavigate } from 'react-router-dom';

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Check for adminToken in localStorage
    const adminToken = localStorage.getItem('adminToken');
    if (!adminToken) {
      navigate('/');
    }
  }, [navigate]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen">
      <Helmet>
        <title>Admin Dashboard | AfricFresh</title>
        <meta name="description" content="AfricFresh administration panel for managing products, orders, and users" />
        <meta property="og:title" content="Admin Dashboard | AfricFresh" />
        <meta property="og:description" content="Manage AfricFresh eCommerce platform" />
      </Helmet>

      <Sidebar isOpen={isSidebarOpen} />
      
      <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-20'}`}>
        <Navbar toggleSidebar={toggleSidebar} />
        
        <main className="flex-1 p-6 bg-gray-100 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;